import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CtaSection() {
  return <section id="cta" className="py-24 bg-gradient-to-br from-sky-500 to-sky-600 relative overflow-hidden" data-id="element-11">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-12">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white/10 rounded-full blur-3xl" data-id="element-13"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white/10 rounded-full blur-3xl" data-id="element-14"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-15">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-16">
          Ready to Tame the Chaos?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-sky-50 mb-10" data-id="element-17">
          Join 2,400+ teams who automated their way to clarity.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-18">
          <button className="bg-white text-sky-600 px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl hover:scale-105 transition-all flex items-center gap-2 mx-auto" data-id="element-19">
            Start Your Free Trial
            <ArrowRight size={20} data-id="element-20" />
          </button>
          <p className="mt-4 text-sky-100 text-sm" data-id="element-21">
            No credit card required. 14-day free trial.
          </p>
        </motion.div>
      </div>
    </section>;
}